module.exports = __webpack_public_path__ + "static/media/computer-light.bfadd2fc.svg";